const headers = (headers) => {
    return Object.entries(headers).map(([key, value]) => `\treq.Header.Add("${key}", "${value}");`).join('\n')
}

export default options => {
    let go = `
package main

import (
        "fmt"
        "strings"
        "net/http"
        "io/ioutil"
)

func main() {
        url
        payload
        req, _ := http.NewRequest(method, url, payload)

headers

        res, _ := http.DefaultClient.Do(req)
        defer res.Body.Close()
        body, _ := ioutil.ReadAll(res.Body)

        fmt.Println(res)
        fmt.Println(string(body))
}
    `
    go = go.replace(/url/i, `url := "${options.url}"`)
    go = go.replace(/payload/i, `payload := strings.NewReader("${JSON.stringify(options.data)}")`)
    go = go.replace(/method/i, `"${options.method.toUpperCase()}"`)
    go = go.replace(/headers/i, `${headers(options.headers)}`)

    return go
}
